import React from "react";

export function HighlightChip({ value }) {
  if (!value) return null;
  const v = String(value);
  let kind = "neutral";
  let label = v;

  if (v === "best") {
    kind = "best";
    label = "★ best";
  } else if (v === "worst") {
    kind = "worst";
    label = "✗ worst";
  } else if (v.startsWith("warn:")) {
    kind = "warn";
    label = `⚠ ${v.slice(5)}`;
  }

  return (
    <span
      className={`highlight-chip highlight-chip--${kind}`}
      aria-label={`status: ${label}`}
      title={label}
    >
      {label}
    </span>
  );
}
